import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import get from 'get-value';
import {isEqual} from 'lodash';
import {storeSelectedCountryGroup} from '../../actions/home/actionHome';
import {errorAlert} from '../../actions/alertsActions';
import {fetchMarketingStatistics} from '../../actions/marketing/actionMarketingStatistics';
import {ALL_COUNTRIES_VALUE, domains} from '../../constants/Utils';
import {moduleRoles} from '../../utils/roles';
import {WrapperHome} from '../common/StyledComponents';
import SelectCountryGroup from '../common/country/SelectCountryGroup';
import StatisticsTable from './StatisticsTable';
import Loader from '../Loader';
import formTypeMessages from '../../intl/modules/formTypeMessages';
import mainPageMessages from '../../intl/common/mainPageMessages';

const DOMAIN = domains.MARKETING;

class MarketingContent extends Component {
    constructor(props) {
        super(props);
        const {userDetail: {roles, group}, selectedCountryGroup, storeSelectedCountryGroup, errorAlert} = props;

        const editorCountryGroups = new Set();
        let isEditor = false;
        let isDealer = false;
        if (moduleRoles.isEditorMarketing(roles)) {
            moduleRoles.getEditorGroups(DOMAIN, roles)
                .forEach(({group}) => editorCountryGroups.add(group));
            isEditor = true;
        }
        if (!isEditor && moduleRoles.isDealerMarketing(roles)) {
            isDealer = true;
            storeSelectedCountryGroup(group, DOMAIN);
            if (!group) {
                errorAlert('User is configured as dealer but does not have any dealer country');
            }
        }
        if (isEditor) {
            if (selectedCountryGroup.length === 0) {
                storeSelectedCountryGroup(ALL_COUNTRIES_VALUE, DOMAIN);
            }
        }
        this.state = {isEditor, isDealer, editorCountryGroups};
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        const {
            selectedCountryGroup, fetchMarketingStatistics, userDetail: {roles, dealerNumber, group},
        } = this.props;
        if (this.state.isEditor && selectedCountryGroup) {
            let selectedMarketingCountryGroups = [selectedCountryGroup];
            if (selectedCountryGroup === ALL_COUNTRIES_VALUE) {
                selectedMarketingCountryGroups = Object.keys(get(roles, `${DOMAIN}.editor.groupPermission`, {default: []}))
                    .filter(countryGroup => roles[DOMAIN].editor.groupPermission[countryGroup] === true);
            }
            fetchMarketingStatistics({countryGroups: selectedMarketingCountryGroups});
        } else if (this.state.isDealer && group && dealerNumber) {
            fetchMarketingStatistics({dealerNumber});
        }
    }

    componentDidUpdate(prevProps) {
        const {selectedCountryGroup} = this.props;

        if (!isEqual(selectedCountryGroup, prevProps.selectedCountryGroup)) {
            this.loadData();
        }
    }

    handleCountryGroupSelection = countryGroup => {
        this.props.storeSelectedCountryGroup(countryGroup.value, DOMAIN);
    };

    render() {
        const {selectedCountryGroup, isLoadingStatistics, statisticData} = this.props;
        const {isEditor, isDealer, editorCountryGroups} = this.state;
        return <>
            <WrapperHome>
                {isEditor &&
                <div className="row mb-sm-3 justify-content-center">
                    <div className="col-12 col-md-6">
                        <SelectCountryGroup groups={[...editorCountryGroups]}
                                            handleCountryGroupSelection={this.handleCountryGroupSelection}
                                            selectedCountryGroup={selectedCountryGroup}
                                            includeSelectionForAll/>
                    </div>
                </div>
                }
                <div className="row mb-sm-3">
                    {(isDealer || isEditor) &&
                    <div className="col-sm-6">
                        <h4><FormattedMessage {...formTypeMessages[DOMAIN]} /></h4>
                    </div>
                    }
                </div>
                {selectedCountryGroup &&
                <>
                    <div className="row mb-sm-5">
                        {(isDealer || isEditor) &&
                        <div className="col-sm-12">
                            <h5>
                                <FormattedMessage {...mainPageMessages.STATISTICS} />
                            </h5>
                            {isLoadingStatistics && <Loader/>}
                            {!isLoadingStatistics &&
                            <StatisticsTable domain={DOMAIN} data={statisticData} group={selectedCountryGroup}/>}
                        </div>
                        }
                    </div>
                </>
                }
            </WrapperHome>
        </>;
    }
}

MarketingContent.propTypes = {
    userDetail: PropTypes.object.isRequired,
    selectedCountryGroup: PropTypes.string.isRequired,
    isLoadingStatistics: PropTypes.bool.isRequired,
    statisticData: PropTypes.array.isRequired,
    storeSelectedCountryGroup: PropTypes.func.isRequired,
    fetchMarketingStatistics: PropTypes.func.isRequired,
    errorAlert: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    userDetail: state.profile.userDetail,
    selectedCountryGroup: get(state, `home.selectedCountryGroup.${DOMAIN}`, ''),
    isLoadingStatistics: get(state, `marketingStatistics.isLoading`),
    statisticData: get(state, `marketingStatistics.data`),
});

export default connect(mapStateToProps, {
    storeSelectedCountryGroup,
    fetchMarketingStatistics,
    errorAlert,
})(MarketingContent);
